import { ValidatorFn, AbstractControl, Validators } from "@angular/forms";

export const mobileOrEmailValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
  const mobilePatern = new RegExp('^[0-9]{10}$');

  const isEmailInvalid = Validators.email(control); // will return error obj if email invalid

  if (mobilePatern.test(control.value) || (!isEmailInvalid)) {
    return null;
  }

  if (isEmailInvalid) {
    return isEmailInvalid;
  }

  if (!mobilePatern.test(control.value)) {
    return { invalidPhoneNumber: { value: control.value } };
  }

  return control.errors;
};
